export default __webpack_public_path__ + "static/media/social_L.2335670a.png";